import FormPage from './formPage';
import enveloppe from '../img/enveloppe.svg'
import api from '../apiConnector'

export default class FrontReceive extends FormPage {
    constructor(props) {
        super(props);
        this.title = 'Recevoir mon devis'
        this.hasNext = false
        this.hasRecap = false
        this.state = {sent:false}
    }

    componentDidMount() {
        api.post(
            {
                action:'send_devis_email',
                external:(this.props.page == 'receive2')?'solly':'',
                id:this.props.type+this.props.id
            },
            (res)=>{
                this.setState({sent:true})
            }
        )
    }

    next() {
    }

    back() {
        this.props.setPage('landing')
    }

    onSubscribe(container) {
        switch ( this.props.page ) {
            case 'receive':
                container.setPage('details1')
                break
            case 'receive2':
                container.setPage('subscribe_solly')
                break
        }
    }

    doRender(container) {
        return <>                
            <div className="contentvbox">
                <h1 className="top_title">Votre demande a été réalisée avec succès</h1>
                <div className="icontextbutton">
                    <div>
                        <img src={enveloppe}/>
                    </div>
                    <div>
                        <h2>Votre devis a été envoyé par mail !</h2>
                        Finalisez votre souscription facilement ou contactez nos 
                        <b> experts de l'assurance moto et scooter </b> pour toute questions !
                    </div>
                    <div>
                        <button onClick={this.onSubscribe.bind(this,container)}>
                            Finaliser ma souscription
                        </button>
                    </div>
                </div>
            </div>
        </>
    }
}
